import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import BackButton from '../../components/ProgressSteps/ProgressButtons/BackButton';
import ProgressButtonContainer from '../../components/ProgressSteps/ProgressButtons/ProgressButtonContainer';
import CaliforniaWarningText from '../../v2/components/CaliforniaWarningText/CaliforniaWarningText';
import getIsInApmExperiment
from '../../v2/selectors/PaymentOptionSelectors/ApmExperimentSelectors/getIsInApmExperiment';
import getIsInApmExperimentWave3Variant1
from '../../v2/selectors/PaymentOptionSelectors/ApmExperimentSelectors/getIsInApmExperimentWave3Variant1';
import getShouldHideCheckoutSubmitButton
from '../../v2/selectors/PaymentOptionSelectors/ApmExperimentSelectors/getShouldHideCheckoutSubmitButton';
import {getSettings} from '../../v2/selectors/selectors';
import SubmitButton from './SubmitButton/SubmitButton';
import TermsAndConditions from './TermsAndConditions/TermsAndConditions';

export function CheckoutSubmitSection(props) {
  return (
    <>
      {!props.shouldHideSubmitButton && (
        <ProgressButtonContainer sticky={props.sticky} background>
          <SubmitButton />
        </ProgressButtonContainer>
      )}

      <BackButton />
  
      {!props.shouldHideSubmitButton && (
        <TermsAndConditions />
      )}
      <CaliforniaWarningText />
    </>
  );
}

CheckoutSubmitSection.propTypes = {
  sticky: PropTypes.bool.isRequired,
  shouldHideSubmitButton: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  sticky: getIsInApmExperiment(state)
    ? !!getIsInApmExperimentWave3Variant1(state)
    : !getSettings(state)?.remove_sticky_submit_button,
  shouldHideSubmitButton: getShouldHideCheckoutSubmitButton(state),
});

export default connect(mapStateToProps)(CheckoutSubmitSection);
